export const humanCategories = [
    {
        key: 'qna',
        models: [
            { model: 'QnAContent', link: '/pluginbot_qna/training' },
            { model: 'QnADocument', link: '/pluginbot_qna/training' },
            { model: 'QnAPackage', link: '/pluginbot_qna/templates' },
            { model: 'QnANode', link: '/pluginbot_qna' },
            { model: 'QnAAgent', link: '/pluginbot_qna/training' },
            { model: 'QnAPackageContent', link: '/pluginbot_qna' },
            { model: 'QnASuggestion', link: '/pluginbot_qna' },
        ],
    },
    {
        key: 'conversations',
        models: [
            { model: 'ConversationDialog', link: '/tools/dialogs' },
            { model: 'ConversationTrigger', link: '/tools/dialogs' },
            { model: 'ConversationCondition', link: '/tools/dialogs' },
            { model: 'ConversationIdentifier', link: '/tools/dialogs' },
            { model: 'ConversationContactIdentifier', link: '/tools/dialogs' },
            { model: 'AnswerGroup', link: '/tools/dialogs' },
        ],
    },
    {
        key: 'content',
        models: [
            { model: 'Article', link: '/articles' },
            { model: 'ArticleCategory', link: '/articles/categories' },
            { model: 'Album', link: '/galleries' },
            { model: 'AlbumObject', link: '/galleries' },
            { model: 'TypeAlbum', link: '/galleries' },
            { model: 'ApplicationContent', link: '/applications' },
            { model: 'ApplicationFormatter', link: '/applications' },
            { model: 'InfoFormatter', link: '/tools/info_formatters' },
        ],
    },
    {
        key: 'robotics',
        models: [
            { model: 'Robot', link: '/robots' },
            { model: 'RobotTransfer', link: '/robots' },
            { model: 'RobotApplication', link: '/robots' },
            { model: 'Action', link: '/tools/autonomous_actions' },
            { model: 'AutonomousAction', link: '/tools/autonomous_actions' },
            { model: 'ApplicationRobottype', link: '/robots' },
            { model: 'ApptypeRobottype', link: '/robottypes' },
            { model: 'ContentRobottype', link: '/robots' },
            { model: 'VisionIdentifier', link: '/robots' },
            { model: 'MapPointIdentifier', link: '/tools/maps' },
        ],
    },
    {
        key: 'apps',
        models: [
            { model: 'Application', link: '/applications' },
            { model: 'ApplicationKey', link: '/applications' },
            { model: 'License', link: '/admin/pluginspaces' },
            { model: 'AppVersion', link: '/applications' },
            { model: 'File', link: '/' },
            {
                model: 'CardDashboardPluginspace',
                link: '/admin/pluginspaces',
                alias: 'updater',
            },
        ],
    },
    {
        key: 'access',
        models: [
            { model: 'Group', link: '/groups' },
            { model: 'GroupUser', link: '/groups' },
            { model: 'GroupSection', link: '/groups' },
            { model: 'GroupSectionUser', link: '/groups' },
            { model: 'RC3Policy', link: '/rc3_settings' },
            { model: 'RC3Principal', link: '/rc3_clients' },
            { model: 'RC3PrincipalPolicy', link: '/rc3_settings' },
            { model: 'Invite', link: '/groups' },
        ],
    },
    {
        key: 'navigation',
        models: [
            { model: 'Location', link: '/pluginspace/locations' },
            { model: 'LocationZone', link: '/pluginspace/locations' },
            { model: 'Map', link: '/tools/maps' },
            { model: 'MapLayer', link: '/tools/maps' },
            { model: 'MapPoint', link: '/tools/maps' },
        ],
    },
    {
        key: 'plugins',
        models: [
            { model: 'Pluginspace', link: '/pluginspace/settings' },
            { model: 'PluginspaceUser', link: '/pluginspace/users' },
            { model: 'PluginspaceAction', link: '/plugins' },
            { model: 'PluginspaceAddon', link: '/plugins' },
            { model: 'PluginspaceTool', link: '/plugins' },
            { model: 'PluginspacePlugintype', link: '/plugins' },
            { model: 'Plugintemplate', link: '/plugintypes' },
            { model: 'Pluginconfig', link: '/pluginspace/settings' },
            { model: 'ToolPlugintype', link: '/plugintypes' },
            { model: 'PluginstoreDependency', link: '/pluginstore/apps' },
        ],
    },
    {
        key: 'operations',
        models: [
            { model: 'TelepresenceList', link: '/tools/contact_lists' },
            { model: 'TelepresenceContact', link: '/tools/contacts' },
            { model: 'TelepresenceCall', link: '/tools/contacts' },
            { model: 'SurveyStep', link: '/plugins' },
            { model: 'ScriptStep', link: '/tools/scripts' },
            { model: 'MissionRequest', link: '/reports' },
            { model: 'MissionRun', link: '/reports' },
        ],
    },
];

export const machineCategories = [
    {
        key: 'robot_telemetry',
        models: [
            { model: 'AutonomousActionLog', link: '/tools/autonomous_actions' },
            { model: 'RobotInteraction', link: '/interactions' },
            { model: 'DeliveryRun', link: '/reports' },
            { model: 'DisinfectionRun', link: '/reports' },
            { model: 'PuduCleaningTask', link: '/cleaning-reports' },
        ],
    },
    {
        key: 'plugin_telemetry',
        models: [
            { model: 'Pluginlog', link: '/plugins' },
            { model: 'PluginspaceLog', link: '/admin/pluginspaces' },
            { model: 'PluginsessionRun', link: '/plugins' },
            { model: 'ConversationMessage', link: '/interactions' },
            { model: 'ConversationContext', link: '/interactions' },
            {
                model: 'PresentationMessage',
                link: '/tools/presentation_contents',
            },
        ],
    },
    {
        key: 'general_execution',
        models: [
            { model: 'UserLog', link: '/sysadmin', alias: 'user' },
            { model: 'ExtractionLog', link: '/extractions' },
            { model: 'SurveyLog', link: '/reports' },
            { model: 'ScriptRun', link: '/tools/scripts' },
            { model: 'TelepresenceAnswer', link: '/tools/contacts' },
            { model: 'AppDownload', link: '/applications' },
        ],
    },
];

export const allModelsList = [...humanCategories, ...machineCategories].flatMap(
    c => c.models
);

export const getModelLink = modelName => {
    const found = allModelsList.find(m => m.model === modelName);
    return found ? found.link : '/';
};

export const getCategoriesOptions = type => {
    const cats = type === 'machine' ? machineCategories : humanCategories;
    return [
        {
            labelKey: 'system_logs.category.general',
            options: [{ value: 'all', labelKey: 'system_logs.filter.all' }],
        },
        ...cats.map(cat => ({
            labelKey: `system_logs.category.${cat.key}`,
            options: [
                {
                    value: cat.key,
                    labelKey: 'system_logs.filter.module_entire',
                    labelParams: { module: cat.key },
                },
                ...cat.models.map(m => ({
                    value: m.model,
                    labelKey: `model.name.${m.model}`,
                })),
            ],
        })),
    ];
};
